<template>
    <div v-separator-link="200">
        <div class="gcmcn-form-title">{{ takerGroup ? 'Edit' : 'Add'}} taker group</div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item class="gcmcn-form-input" prop="name">
                    <div class="gcmcn-form-label">Name</div>
                    <el-input
                        size="mini"
                        v-model="form.name"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    class="gcmcn-form-input"
                    prop="entity_uid"
                >
                    <div class="gcmcn-form-label">Entity</div>
                    <el-select
                        v-model="form.entity_uid"
                        popper-class="gcmcn-popper"
                        size="mini"
                        placeholder="Select an entity"
                        :disabled="takerGroup !== null"
                    >
                        <el-option
                            v-for="entity in $store.getters.entities"
                            :key="entity.uid"
                            :label="entity.display_name"
                            :value="entity.uid"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    class="gcmcn-form-input"
                    prop="takers_uid"
                >
                    <div class="gcmcn-form-label">Takers</div>
                    <el-select
                        v-model="form.takers_uid"
                        popper-class="gcmcn-popper"
                        size="mini"
                        placeholder="Select takers"
                        :disabled="!form.entity_uid"
                        multiple
                    >
                        <el-option
                            v-for="taker in takersFiltered"
                            :key="taker.uid"
                            :label="taker.name"
                            :value="taker.uid"
                        ></el-option>
                    </el-select>
                    <div
                        v-if="takerGroup && $store.getters.entities.length > 1"
                        class="form-info"
                    >
                        Only takers related to the same entity are displayed.
                    </div>
                </el-form-item>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm">Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        takerGroup: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
    },

    data (){
        return {
            loading: false,
            form: {
                name: '',
                takers_uid: null,
                entity_uid: '',
            },
        };
    },

    computed: {
        rules () {
            return {
                name: [{ required: true }],
                takers_uid: [{ required: true }],
                entity_uid: [{ required: this.takerGroup ? false : true}]
            };
        },

        takersFiltered (){
            return this.$store.getters.takers.filter((taker) => {
                return taker.scopes.entity_uid === this.form.entity_uid;
            });
        }
    },

    watch: {
        takerGroup: {
            handler (){
                this.setForm();
            },
            deep: true,
            immediate: true,
        },
        'form.entity_uid' (){
            this.$set(this.form, 'takers_uid', []);
        },
    },
    mounted (){

    },

    methods: {
        setForm (){
            if(this.takerGroup){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.takerGroup)));
                this.form.entity_uid = this.takerGroup.scopes.entity_uid;
            }else{
                this.$set(this, 'form', {
                    name: '',
                    takers_uid: [],
                    entity_uid: this.$store.getters.entities.length === 1 ? this.$store.getters.entities[0].uid : '',
                });
            }
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let form = JSON.parse(JSON.stringify(this.form));
                    let action;
                    let postData = { item: form, model: 'takerGroups'};
                    let messageType = this.takerGroup ? 'update' : 'create';
                    if(this.takerGroup){
                        action = 'patchItem';
                        this.form.url = this.takerGroup.url;

                    }else{
                        action = 'createItem';
                        form.can_admin_users = [this.$store.getters.currentUser.uid];
                        postData.url = this.$store.state.api.meta.listModels.takerGroups.url;
                        postData.scopes = {'X-Entity-Uid': this.form.entity_uid};
                    }
                    this.$store.dispatch(action, postData).then(() => {
                        this.$message({
                            message: `Taker group ${messageType}d!`,
                            type: 'success'
                        });
                        this.loading = false;
                        this.$emit('leave-form-view');
                    }).catch((e) => {
                        this.loading = false;
                        console.error(e);
                        this.$message.error(`Error on taker group ${messageType === 'update' ? messageType : 'creation'}.`);
                    });
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/RightGroup/taker-group-form.vue